import OldInertiaRouter from './old'
import type { InertiaRouter, ComponentFile, GlobImport, LazyGlobImport } from './types'

let inertiaRouter = undefined as any as InertiaRouter
if (import.meta.env.DEV && typeof window !== 'undefined') {
  inertiaRouter = (window as any)?.__dev?.inertiaRouter
}

export const createInertiaRouter = (): InertiaRouter => {
  inertiaRouter = new OldInertiaRouter()
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    ;(window as any).__dev = { ...(window as any).__dev, inertiaRouter }
  }

  return inertiaRouter
}

export function fromEagerToLazyGlobImport(
  imports: GlobImport<ComponentFile>,
): LazyGlobImport<ComponentFile> {
  return Object.fromEntries(
    Object.entries(imports).map(([key, value]) => [key, () => Promise.resolve(value)]),
  )
}

export function getInertiaRouter(): InertiaRouter {
  if (!inertiaRouter) {
    throw new Error('Inertia Router has not been created yet.')
  }

  return inertiaRouter
}

export * from './types'
export * from './config'
export * from './prefetch'
